import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { NAV_LIST, hasAnyPermission } from '@/common/js/constant/index.ts';
let Nav = class Nav extends Vue {
    get filteredNavList() {
        return NAV_LIST.filter((item) => {
            const platformMatch = item.platform.includes('desktop');
            const permissionMatch = !item.requiredPermissions
                || item.requiredPermissions.length === 0
                || hasAnyPermission(...item.requiredPermissions);
            return platformMatch && permissionMatch;
        });
    }
    get curNav() {
        const routeList = this.$route.matched;
        for (const route of routeList) {
            for (const nav of this.filteredNavList) {
                if (nav.name === route.name) {
                    return [nav.name];
                }
            }
        }
        return [];
    }
    set curNav(val) { }
};
Nav = __decorate([
    Component
], Nav);
export default Nav;
